import React from 'react';
import "../../Header/Header.css"
import "./HeaderMenu.css";
import * as ReactBootStrap from 'react-bootstrap';
import {NavLink  } from 'react-router-dom';


function HeaderMenu(props) {
  
    return(  
  
  <div className="col-lg-12 full-width menu-top p-0 m-0">
  <ReactBootStrap.Navbar collapseOnSelect expand="md" className="pl-0 p-1">
  <ReactBootStrap.Navbar.Toggle aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" style={{borderColor:"white"}}/>
  <ReactBootStrap.Navbar.Collapse id="responsive-navbar-nav">
      <ReactBootStrap.Nav>
        <ReactBootStrap.Nav.Link as={NavLink} to="/companies"  className={props.link1}>Companies</ReactBootStrap.Nav.Link>
        <ReactBootStrap.Nav.Link as={NavLink} to="/products" className={props.link2}>Products</ReactBootStrap.Nav.Link>  
        <ReactBootStrap.Nav.Link as={NavLink} to="/successstories" className={props.link3} style={{minWidth:"150px"}}>Success Stories</ReactBootStrap.Nav.Link>
        <ReactBootStrap.Nav.Link as={NavLink} to="/industry" className={props.link4}>Industries</ReactBootStrap.Nav.Link>        
      </ReactBootStrap.Nav>
    </ReactBootStrap.Navbar.Collapse>  
  </ReactBootStrap.Navbar>
  </div>
  
    );}

export default HeaderMenu;